import { Box, Tooltip, Typography } from "@mui/material";
import styles from "./Card.module.scss";
import { FC, ReactNode } from "react";
import { InfoOutlined } from "@mui/icons-material";

interface CardProps {
  cardTitle?: string;
  cardSubTitle?: string;
  children: ReactNode;
  infoText?: string;
}

const Card: FC<CardProps> = ({
  cardTitle,
  cardSubTitle,
  children,
  infoText,
}) => {
  return (
    <Box className={styles.container}>
      {cardTitle && (
        <Box className={styles.title}>
          <Typography className={styles.cardTitle}>{cardTitle}</Typography>
          {infoText && (
            <Tooltip title={infoText}>
              <InfoOutlined />
            </Tooltip>
          )}
        </Box>
      )}
      {cardSubTitle && (
        <Typography className={styles.cardSubTitle}>{cardSubTitle}</Typography>
      )}
      {children}{" "}
    </Box>
  );
};

export default Card;
